export default __webpack_public_path__ + "static/media/banner2026.c89b4a82.png";